import React from 'react';
import { AlertCircle, Lightbulb, Cpu, BarChart3 } from 'lucide-react';

const Projects = ({ t }) => {
  const projectImages = [
    'https://images.unsplash.com/photo-1761195696590-3490ea770aa1?q=80&w=800',
    'https://images.unsplash.com/photo-1536104968055-4d61aa56f46a?q=80&w=800',
    'https://images.pexels.com/photos/11035481/pexels-photo-11035481.jpeg?w=800',
    'https://images.unsplash.com/photo-1689942009554-759940987be0?q=80&w=800',
    'https://images.unsplash.com/photo-1768323275769-6615e7cfcbe4?q=80&w=800',
    'https://images.unsplash.com/photo-1555952494-efd681c7e3f9?q=80&w=800'
  ];

  return (
    <section id="projects" className="projects-section">
      <div className="container">
        <h2 className="section-title">{t.projects.title}</h2>
        
        <div className="projects-grid">
          {t.projects.items.map((project, index) => (
            <div key={index} className="project-card">
              <div className="project-image-container">
                <img 
                  src={projectImages[index]} 
                  alt={project.title} 
                  className="project-image"
                />
              </div>
              
              <div className="project-content">
                <h3 className="project-title">{project.title}</h3>
                
                <div className="project-section">
                  <div className="project-label">
                    <AlertCircle size={16} />
                    {t.projects.labels.problem}
                  </div>
                  <p className="project-text">{project.problem}</p>
                </div>
                
                <div className="project-section">
                  <div className="project-label">
                    <Lightbulb size={16} />
                    {t.projects.labels.solution}
                  </div>
                  <p className="project-text">{project.solution}</p>
                </div>
                
                <div className="project-section">
                  <div className="project-label">
                    <Cpu size={16} />
                    {t.projects.labels.tech}
                  </div>
                  <p className="project-tech">{project.tech}</p>
                </div>
                
                <div className="project-section">
                  <div className="project-label">
                    <BarChart3 size={16} />
                    {t.projects.labels.result}
                  </div>
                  <p className="project-result">{project.result}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;